import { createPortal } from "react-dom";

/**
 * ModalPortal — escapes local stacking contexts by portaling children
 * to `document.body`. Required because our page wrappers (e.g.
 * `.container-x.relative.z-10`) create new stacking contexts that trap
 * `fixed inset-0 z-[70]` overlays visually below the fixed site header
 * (which sits at the root stacking context with z-50).
 */
export const ModalPortal = ({ children }) => {
    if (typeof document === "undefined") return null;
    return createPortal(children, document.body);
};
